var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.868 1.59a1.113 1.113 0 011.074-.822H47.68c.615 0 1.113.499 1.113 1.113v8.946c0 .615-.498 1.114-1.113 1.114H8.519a1.113 1.113 0 01-1.075-1.405L9.868 1.59z",
    fill: "url(#userType_svg__paint0_linear_5580_14288)",
    stroke: "url(#userType_svg__paint1_linear_5580_14288)",
    strokeWidth: 0.414
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.188 2.484h.521a10.476 10.476 0 003.233 2.405l-.388.686a10.048 10.048 0 01-3.106-2.458c-.79.953-1.84 1.772-3.135 2.465l-.38-.685c1.303-.64 2.39-1.445 3.255-2.413zm.119 2.003h.707v1.594h1.974v.678h-1.974v1.639h2.51v.685h-6.241v-.685h1.072V5.56h.7v2.838h1.252v-3.91zm6.428-1.951h.707V8.39h.894V2.536h.708V8.39h2.174v.693h-6.643V8.39h2.16V2.536zm3.701 1.385l.626.179c-.283 1.281-.648 2.398-1.095 3.36l-.633-.224c.417-.864.79-1.974 1.102-3.315zm-5.11-.015c.38.998.716 2.138 1.014 3.419l-.648.164a27.385 27.385 0 00-.968-3.39l.603-.193zm7.978 1.274v1.14h1.713V5.18h-1.713zm-.037 1.795c-.09.938-.365 1.713-.827 2.324l-.544-.484c.447-.64.678-1.453.693-2.436V2.73h5.713v5.609c0 .559-.29.842-.857.842h-.856l-.186-.693c.29.022.558.037.811.037.239 0 .365-.149.365-.44v-1.11h-1.847v2.124h-.715V6.975h-1.75zm4.312-.656V5.18h-1.847v1.14h1.847zm0-1.787V3.415h-1.847v1.117h1.847zm-2.562-1.117h-1.713v1.117h1.713V3.415zm9.891.61H40.85v1.267h4.06V4.025zm-4.066 1.96c-.045 1.31-.388 2.45-1.036 3.403l-.521-.477c.566-.811.857-1.862.864-3.143V3.333h2.39a6.142 6.142 0 00-.401-.797l.76-.12c.126.276.245.582.364.917h2.361v2.651h-4.781z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.438 11.797a.828.828 0 001.193 0l5.964-6.203a.828.828 0 00.079-1.052L11.118.932a.827.827 0 00-.676-.35H3.626c-.268 0-.52.131-.675.35L.395 4.542a.828.828 0 00.08 1.052l5.963 6.203z",
    fill: "#2C0309"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.918 2.486a2.782 2.782 0 00-2.073 4.638 2.762 2.762 0 002.073.935c.66 0 1.258-.228 1.738-.612a2.225 2.225 0 00-.348-.323 2.31 2.31 0 01-1.39.467 2.337 2.337 0 01-1.737-.79c-.072-.085-.144-.18-.216-.276-.24-.36-.372-.791-.372-1.259a2.327 2.327 0 012.325-2.325 2.327 2.327 0 012.325 2.325c0 .468-.144.9-.371 1.259.12.095.24.203.347.323.312-.443.491-.994.491-1.582a2.8 2.8 0 00-2.792-2.78z",
    fill: "#FFD3DA",
    stroke: "#FFD3DA",
    strokeWidth: 0.248
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.991 7.148c-.108-.12-.215-.24-.335-.336a2.804 2.804 0 00-.851-.467 2.698 2.698 0 00-.887-.144.923.923 0 11.923-.923c0 .252-.096.48-.264.647.168.036.324.084.48.144a1.41 1.41 0 00.251-.79c0-.768-.623-1.39-1.39-1.39a1.38 1.38 0 00-1.39 1.377c0 .3.096.576.252.791a1.366 1.366 0 001.138.6c.515 0 .995.18 1.39.467.132.096.24.228.348.347.156.18.287.408.383.635h.504a3.176 3.176 0 00-.552-.958z",
    fill: "url(#userType_svg__paint2_linear_5580_14288)",
    stroke: "url(#userType_svg__paint3_linear_5580_14288)",
    strokeWidth: 0.248
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "userType_svg__paint0_linear_5580_14288",
    x1: 50.525,
    y1: 0.49,
    x2: 7.375,
    y2: 9.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "userType_svg__paint1_linear_5580_14288",
    x1: 51.418,
    y1: 6.283,
    x2: 9.471,
    y2: 6.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD0C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "userType_svg__paint2_linear_5580_14288",
    x1: 9.385,
    y1: 3.862,
    x2: 5.435,
    y2: 4.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "userType_svg__paint3_linear_5580_14288",
    x1: 9.385,
    y1: 3.862,
    x2: 5.435,
    y2: 4.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })))));
}
export default SvgUserType;